import * as UI from "@iyk/ui"
import * as React from "react"

type AvatarProps = {
  src?: string
  className?: string
  displayName: string
  kind?: "square" | "circle"
  size: AvatarSize
}

export type AvatarSize = "xxs" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl"

export const Avatar = ({ displayName, src, kind = "circle", className, size }: AvatarProps) => {
  const [imgError, setImgError] = React.useState(false)

  React.useEffect(() => {
    setImgError(false)
  }, [src])

  if (src && !imgError) {
    return (
      <span className={classForAvatar({ kind, className, size })}>
        <img
          src={src}
          alt={`${displayName}'s avatar`}
          className="size-full object-cover"
          loading="lazy"
          onError={() => setImgError(true)}
        />
      </span>
    )
  }

  return (
    <span className={classForAvatar({ kind, className, size })}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className="size-full">
        <text
          x="50%"
          y="50%"
          fill="currentColor"
          dominantBaseline="central"
          fontFamily="Departure Mono"
          fontSize="9"
          fontWeight="300"
          textAnchor="middle"
        >
          {displayName[0]?.toUpperCase() ?? ""}
        </text>
      </svg>
    </span>
  )
}

const classForAvatar = UI.cva(
  [
    "shrink-0 aspect-square",
    "flex items-center justify-center",
    "bg-gray-3 text-gray-9",
    "relative overflow-hidden",
    "after:content-[''] after:absolute after:inset-0 after:z-10 after:bshadow after:bshadow-grayA-3-light after:pointer-events-none"
  ],
  {
    variants: {
      kind: {
        square: "rounded after:rounded-sm",
        circle: "rounded-full after:rounded-full"
      },
      size: {
        xxs: "size-5",
        xs: "size-6",
        sm: "size-7",
        md: "size-8",
        lg: "size-12",
        xl: "size-16",
        xxl: "size-20"
      }
    },
    defaultVariants: {
      kind: "circle"
    }
  }
)
